<template>
    <div class="updates-modal" v-if="!close">
        <div class="updates-modal__window">
            <div class="updates-modal__content">
                <div class="updates-modal__title">
                    <span v-if="client"
                        >Идёт обновление web-приложения KPam-3D</span
                    >
                    <span v-else
                        >Обновление web-приложения KPam-3D до v
                        {{ version?.version_number }}</span
                    >
                </div>
                <div class="updates-modal__body">
                    <div v-if="client" class="client-messages">
                        <p>Извините за доставленные неудобства.</p>
                        <p>Пожалуйста, зайдите попозже!</p>
                    </div>
                    <div v-else>
                        <div
                            class="upgrade-info wrapper-x-40 mt-8"
                            v-if="updatingProgress"
                        >
                            <div
                                class="upgrade-info__failed"
                                v-if="
                                    updatingProgress.failed &&
                                    parseInt(updatingProgress.failed) == 1
                                "
                            >
                                Обновление завершилось неудачей
                            </div>
                            <div class="upgrade-info__version">
                                Версия обновления:
                                <span>{{ updatingProgress.version_to }}</span>
                            </div>
                            <div
                                class="upgrade-info__message"
                                v-if="updatingProgress.version_to"
                            >
                                {{ updatingProgress.message }}
                            </div>
                            <div class="upgrade-info__start_finish">
                                <div class="upgrade-info__start">
                                    Начало:
                                    <span>{{
                                        updatingProgress.started_at
                                    }}</span>
                                </div>
                            </div>
                            <div
                                class="upgrade-info__stages"
                                v-if="updatingProgress.upgrade_stages"
                            >
                                <div class="upgrade-stage__title">
                                    Стадии обновления
                                </div>
                                <div
                                    class="upgrade-stage"
                                    v-for="(
                                        stage, index
                                    ) of updatingProgress.upgrade_stages"
                                    :key="`stage-${stage.id}`"
                                >
                                    <div>
                                        <div class="upgrade-stage__index">
                                            {{ index + 1 }}.
                                        </div>
                                        <div class="upgrade-stage__name">
                                            {{ stage.name }}
                                        </div>
                                        <div
                                            v-if="
                                                stage.success &&
                                                parseInt(stage.success) === 1
                                            "
                                        >
                                            <i class="fa fa-check"></i>
                                        </div>
                                        <div
                                            v-if="
                                                stage.failed &&
                                                parseInt(stage.failed) === 1
                                            "
                                        >
                                            <i class="fa fa-times"></i>
                                        </div>
                                        <div
                                            v-if="
                                                stage.processing &&
                                                parseInt(stage.processing) === 1
                                            "
                                        >
                                            <img
                                                src="/images/icons/update-animation.gif"
                                                alt=""
                                            />
                                        </div>
                                    </div>
                                    <div>
                                        <div
                                            v-if="stage.message"
                                            class="upgrade-stage__message"
                                            :class="{
                                                error:
                                                    stage.failed &&
                                                    parseInt(stage.failed) ===
                                                        1,
                                            }"
                                        >
                                            {{ stage.message }}
                                        </div>
                                        <div>
                                            Прогресс - {{ stage.progress }}%
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            class="updates-processing"
                            v-if="mode == 'processing'"
                        >
                            <div class="updates-processing__numbers">
                                <div
                                    class="updates-processing__numbers-finished"
                                >
                                    {{ processingReady }}
                                </div>
                                <div>/</div>
                                <div class="updates-processing__numbers-total">
                                    100
                                </div>
                                <div>%</div>
                            </div>
                            <div class="updates-processing__sliders">
                                <div
                                    class="updates-processing__sliders-ready"
                                    :style="{ width: sliderWidth }"
                                ></div>
                            </div>
                        </div>
                        <div
                            class="updates-processing"
                            v-if="mode == 'success'"
                        >
                            <div class="updates-processing__numbers">
                                <div
                                    class="updates-processing__numbers-finished"
                                >
                                    Успешно завершено!
                                </div>
                            </div>
                            <div class="text-center">
                                <button
                                    class="btn btn-green"
                                    @click="close = true"
                                >
                                    Закрыть
                                </button>
                            </div>
                        </div>
                        <div class="updates-processing" v-if="mode == 'failed'">
                            <div class="updates-failed-title text-center">
                                Завершено с ошибкой! Установка отменена!
                            </div>
                            <div class="updates-failed-message text-center">
                                Не удалось распаковать архив
                            </div>
                            <div class="updates-recomendation text-center">
                                Рекомендуется связаться с администратором или
                                разработчиком.
                            </div>
                            <div class="text-center">
                                <button
                                    class="btn btn-green"
                                    @click="close = true"
                                >
                                    Закрыть
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "UpdateModal",
    data() {
        return {
            checkInstallInterval: null,
            close: false,
            mode: "processing",
        };
    },

    props: {
        client: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        version() {
            return this.$store.state.versions.version;
        },
        updatingProgress() {
            return this.$store.state.versions.updatingProgress;
        },
        loading() {
            return this.$store.state.versions.loading;
        },
        processingReady() {
            this.$store.state.versions.updatingProgress;

            if (
                this.$store.state.versions.updatingProgress &&
                !this.$store.state.versions.updatingProgress.processing &&
                parseInt(
                    this.$store.state.versions.updatingProgress.processing
                ) === 0
            ) {
                clearInterval(this.checkInstallInterval);
                this.checkInstallInterval = null;
            } else if (
                this.$store.state.versions.updatingProgress &&
                this.$store.state.versions.updatingProgress.progress != 100
            ) {
                if (!this.checkInstallInterval) {
                    this.checkInstallInterval = setInterval(() => {
                        this.$store.dispatch("versions/checkUpgradeInfo");
                        console.log("update--interval");
                    }, 2000);
                }
            }

            return this.$store.state.versions.updatingProgress.progress;
        },
        sliderWidth() {
            return `${this.processingReady}%`;
        },
    },
};
</script>
<style scoped>
.updates-modal {
    position: fixed;
    z-index: 10001;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.5);
    display: grid;
    place-content: center;
}
.updates-modal__window {
    width: 660px;
    box-shadow: 0 0 20px #cecece;
    border-radius: 15px;
    background-color: #fff;
    padding: 30px 20px;
}
.updates-modal__title {
    font-size: 18px;
    font-weight: 600;
    text-align: center;
    margin-bottom: 30px;
}
.updates-processing__numbers {
    font-size: 24px;
    margin-bottom: 15px;
    display: flex;
    gap: 9px;
    justify-content: center;
}
.updates-processing__numbers-finished {
    color: #6bc07c;
    font-weight: 500;
}
.updates-processing__sliders {
    height: 3px;
    border-radius: 2px;
    background-color: #dee2e6;
    display: flex;
}
.updates-processing__sliders-ready {
    height: 3px;
    background-color: #6bc07c;
}
.updates-failed-title {
    color: #ff0000;
    font-size: 24px;
    margin-bottom: 15px;
}
.updates-failed-message {
    font-size: 18px;
    margin-bottom: 20px;
}
.updates-recomendation {
    font-size: 14px;
    margin-bottom: 25px;
}
.client-messages {
    text-align: center;
    font-size: 18px;
}
</style>
